import { useInfiniteQuery } from '@tanstack/react-query'
import { api } from 'api'
import { toaster } from 'uikit/Toaster'

const historyListAdapter = (content: any) => {
  return content.reduce((acc: any, current: any) => {
    const { fields, ...rest } = current

    const newFields = fields.map((item: any, index: any) => ({
      ...item,
      ...rest,
      id: `${rest.id}-${item.columnName}-${index}`,
    }))

    acc.push(...newFields)
    return acc
  }, [])
}

export const useFetchJournalList = (objectId: string) => {
  let list = []
  let lastPage

  const query = useInfiniteQuery({
    queryKey: ['passportJournal'],
    queryFn: ({ pageParam }) => {
      return api.journal.fetchList({ objectId, page: pageParam, size: 20 })
    },
    initialPageParam: 0,
    getNextPageParam: ({ number }) => number + 1,
  })

  if (query.isError) {
    toaster.create({
      type: 'error',
      title: 'Произошла ошибка при загрузки истории смены данных',
      description: query.error?.message,
    })
  }

  if (query.data?.pages) {
    const content = query.data.pages.reduce((acc, item) => [...acc, ...item.content], [])
    list = content?.length ? historyListAdapter(content) : []
    lastPage = query.data.pages[query.data.pages.length - 1]
  }

  return {
    list,
    hasMore: !lastPage?.last,
    ...query,
  }
}
